(function () {
  console.log("Free Shipping Bar Script Loaded");

  if (window.location.pathname === "/pages/agood-company-for-business") {
    return;
  }

  const bar = document.getElementById("free-shipping-bar");
  if (!bar) return;

  bar.innerHTML = `
    <div id="free-shipping-bar-right" class="free-shipping-text">
      You're away from FREE shipping.
    </div>
  `;

  bar.style.display = "flex";
  bar.style.justifyContent = "flex-end";
  bar.style.alignItems = "center";
  bar.style.color = "#fff";
  bar.style.padding = "10px 20px";

const thresholdsByCountry = {
  EUR: {
    countries: [
      "BE","NL","LU"
    ],
    threshold: 36
  },

  EUR_EU: {
    countries: [
      "FR","IT","ES","PT","IE","AT","CZ","SK","HU","EE","LV","LT","PL","RO","BG","GR","HR","SI","MT"
    ],
    threshold: 35
  },

  DE_EUR: {
    countries: ["DE"],
    threshold: 60
  },

  FI_EUR: {
    countries: ["FI"],
    threshold: 25
  },

  SEK: {
    countries: ["SE"],
    threshold: 300
  },

  NOK: {
    countries: ["NO"],
    threshold: 300
  },

  DKK: {
    countries: ["DK"],
    threshold: 200
  },

  GBP: {
    countries: ["GB"],
    threshold: 26
  },

  USD: {
    countries: ["US"],
    threshold: 60
  },

  CAD: {
    countries: ["CA"],
    threshold: 90
  },

  MX_EUR: {
    countries: ["MX"],
    threshold: 57
  },

  CHF: {
    countries: ["CH","LI"],
    threshold: 60
  },

  DEFAULT: {
    available: false,
    message: "Free shipping is not available in your region."
  }
};


  const textEl = document.getElementById("free-shipping-bar-right");

  function getThresholdForCountry(countryCode) {
    for (const data of Object.values(thresholdsByCountry)) {
      if (data.countries && data.countries.includes(countryCode)) {
        return { available: true, threshold: data.threshold };
      }
    }
    return thresholdsByCountry.DEFAULT;
  }

  const activeCountry = window.localization?.country?.iso_code || "";
  const currency = Shopify.currency?.active || "EUR";
  const thresholdData = getThresholdForCountry(activeCountry);

  function updateBar() {
    if (!thresholdData.available) {
      textEl.textContent = thresholdData.message;
      return;
    }

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price / 100;
        const remaining = thresholdData.threshold - total;

        if (remaining > 0) {
          textEl.textContent =
            `You're ${currency} ${remaining.toFixed(2)} away from FREE shipping.`;
        } else {
          textEl.textContent =
            "Congratulations! You qualify for free shipping.";
        }
      })
      .catch(() => {
        textEl.textContent =
          "Unable to calculate free shipping eligibility.";
      });
  }

  updateBar();

  document.addEventListener("cart:updated", updateBar);
  document.addEventListener("cart:refresh", updateBar);
  document.addEventListener("ajaxProduct:added", updateBar);
  document.addEventListener("product:added", updateBar);

  const style = document.createElement("style");
  style.textContent = `
    #free-shipping-bar {
      width: 100%;
      background-color: #e01217;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #fff;
      padding: 10px 20px;
    }

    #free-shipping-bar-right {
      font-size: 14px;
      font-weight: 500;
    }

    @media (max-width: 768px) {
      #free-shipping-bar {
        justify-content: center;
        text-align: center;
        padding: 10px;
      }

      #free-shipping-bar-right {
        font-size: 12px;
      }
    }
  `;
  document.head.appendChild(style);
})();
